import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/users', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/users/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/users', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/users/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/users/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const resetPassword = (id, data) => {
  return httpClient
    .put(`/api/users/reset-passwords/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const switchDefaultBranch = data => {
  return httpClient
    .post('/api/users/switch-default-branches', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const unlock = data => {
  return httpClient
    .post('/api/users/unlock', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changeUserType = data => {
  return httpClient
    .post('/api/users/change-user-types', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changeDisable = (id, data) => {
  return httpClient
    .put(`/api/users/change-disable/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const changeAllAboutMyDay = (id, data) => {
  return httpClient
    .put(`/api/users/change-all-about-my-day/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const currentUser = (Options = {}) => {
  return httpClient
      .get("/api/client/user", Options)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response.data));
};

export default {
  get,
  find,
  store,
  update,
  destroy,
  resetPassword,
  switchDefaultBranch,
  unlock,
  changeUserType,
  changeDisable,
  changeAllAboutMyDay,
  currentUser
}
